<template>
  <div>

  </div>
</template>


<script>
export default {
  name: 'guidedev',

  data() {
    return {

    }
  },
  methods: {},

  //自动触发写入的函数
  mounted: function () {

  }
}

</script>

<style>

</style>